import { render, staticRenderFns } from "./DepartUserList.vue?vue&type=template&id=394ebc3f&scoped=true&"
import script from "./DepartUserList.vue?vue&type=script&lang=js&"
export * from "./DepartUserList.vue?vue&type=script&lang=js&"
import style0 from "./DepartUserList.vue?vue&type=style&index=0&id=394ebc3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ebc3f",
  null
  
)

export default component.exports